import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import './AccountSettings.module.scss';
import {history} from 'components/App/components/UnauthenticatedApp';

import {inspirationData} from 'utilities/Inspiration';

import SideNavigation from 'components/UI/SideNavigation/SideNavigation';
import TopNavigation from 'components/UI/TopNavigation/TopNavigation';
import PageWrapper from 'components/UI/PageWrapper/PageWrapper';
import Button from 'components/UI/Button/Button';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import { faRocket, faGamepad, faChevronLeft, faSignOut, faAngleLeft, faUserCircle } from '@fortawesome/pro-solid-svg-icons';

//import actions
import updateUser from 'actions/user/update';
import logoutUser from 'actions/authentication/logout';

const mapStateToProps = (state, props) => {
    return {
        user: state.authentication.user
    };
};

const mapDispatchToProps = {
    updateUser,
    logoutUser
};


class Inspiration extends Component {

    constructor() {
        super();

        this.state = {
            first_name: '',
            last_name: '',
            email: '',
            current_password: undefined,
            password: undefined,
            password_confirmation: undefined,
            password_dirty: false
        }

        this.updateFirstName = this.updateFirstName.bind(this);
        this.updateLastName = this.updateLastName.bind(this);
        this.updateEmail = this.updateEmail.bind(this);
        this.updateCurrentPassword = this.updateCurrentPassword.bind(this);
        this.updateNewPassword = this.updateNewPassword.bind(this);
        this.updateNewPasswordConfirm = this.updateNewPasswordConfirm.bind(this);
        this.updateUser = this.updateUser.bind(this);
        this.logoutUser = this.logoutUser.bind(this);
    }
    
    //scroll to top

    componentDidMount() {
        window.scrollTo(0,0);


        this.setState({
            first_name: this.props.user.first_name,
            last_name: this.props.user.last_name,
            email: this.props.user.email
        });
    }

    updateFirstName(event) {
        this.setState({
            first_name: event.target.value
        });
    }

    updateLastName(event) {
        this.setState({
            last_name: event.target.value
        });
    }

    updateEmail(event) {
        this.setState({
            email: event.target.value
        });
    }

    updateCurrentPassword(event) {
        this.setState({
            current_password: event.target.value
        });
    }

    updateNewPassword(event) {
        this.setState({
            password: event.target.value
        });
    }

    updateNewPasswordConfirm(event) {
        this.setState({
            password_confirmation: event.target.value
        });
    }

    updateUser() {
        alert('Gebruiker opslaan');
        this.props.updateUser({
            ...this.state,
            id: this.props.user.id
        });
    }

    goToHome() {
        history.push('/');
    }

    logoutUser() {
        this.props.logoutUser();
    }

    render() {
        return (

            <Fragment>
                <div styleName='main'>
                    <div styleName='maxwidth'>
                        <div styleName='back'>
                            <a onClick={this.goToHome}><FontAwesomeIcon icon={faAngleLeft}/> GA TERUG</a>
                        </div>
                        <div styleName='signout'>
                            <a onClick={this.logoutUser}><FontAwesomeIcon icon={faSignOut}/> UITLOGGEN</a>
                        </div>
                         <div styleName='container'>
                            <div styleName='avatar'>
                                <FontAwesomeIcon styleName="icon" icon={faUserCircle} size="8x" />
                            </div>
                            <h2>{this.props.user && this.props.user.first_name} {this.props.user && this.props.user.last_name}</h2>
                            <h3>GEGEVENS</h3>
                            <label>Voornaam</label><input onChange={this.updateFirstName} value={this.state.first_name} type="text" /><br/>
                            <label>Achternaam</label><input onChange={this.updateLastName} value={this.state.last_name} type="text" /><br/>
                            <label>Email-adres</label><input onChange={this.updateEmail} value={this.state.email} type="text" /><br/>
                            <label>Huidig wachtwoord</label><input onChange={this.updateCurrentPassword} value={this.state.user} type="password" /><br/>
                            <label>Nieuw wachtwoord</label><input onChange={this.updateNewPassword} value={this.state.new_password} type="password" /><br/>
                            <label>Nieuws wachtwoord (check)</label><input onChange={this.updateNewPasswordConfirm} value={this.state.new_password_confirm} type="password" /><br/>
                            <Button style={{marginTop: '40px', fontWeight:'bold'}} text='GEGEVENS AANPASSEN' handleClick={this.updateUser}/>
                         </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Inspiration);


// WEBPACK FOOTER //
// ./resources/assets/screens/AccountSettings/AccountSettings.jsx